import { createContext } from '@shared/utils/createContext';

export interface PayoutAccountInfo {
  status: 'onboarding' | 'readyToUse' | 'pending' | 'rejected';
  statusDetails: string;
  onboardingUrl: string;
  serviceDashboardUrl: string;
  lastKnownBalance: CommerceMonetaryValue | null;
  externalAccountLast4: string | null;
}

export interface CommerceMonetaryValue {
  currencyCode: string;
  valueInMinorUnits: number;
  valueInMajorUnits: number;
}
interface CreditCardSetupContext {
  setSetupCreditCard: (nextValue: string | null) => void;
  fetchingPayoutInfo: boolean;
  payoutAccountInfo: PayoutAccountInfo | null;
  maxAttemptsReached: boolean;
  initKYCOnboarding: () => void;
  initKYCOnboardingFromRefund: (returnRoute: string) => void;
  fetchPayoutInfo: () => void;
  onOpenPayoutDialog: () => void;
}

export const [Provider, useCreditCardSetupContext] = createContext<CreditCardSetupContext>({ name: 'CreditCardSetUpContext' });
